import { graphql } from '@/generated/gql';

export const QUOTE_QUERY = graphql(/* GraphQL */ `
  query Quote($id: UUID!) {
    sevenbridges {
      quote(id: $id) {
        id
        currency
        quoteReference
        lineItems {
          id
          sequence
          position
          title
          description
          quantity
          unitId
          pricePerUnit
          earlyDeliveryAt
          lateDeliveryAt
        }
      }
    }
  }
`);
